import { render, staticRenderFns } from "./ptr.vue?vue&type=template&id=bca39486"
import script from "./ptr.vue?vue&type=script&lang=js"
export * from "./ptr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports